module.exports = __webpack_public_path__ + "static/media/connected.54b6545e.svg";